import { useState, useRef, useEffect } from 'react';
import { Form, Splitter , FloatButton ,Modal,Input} from 'antd';
import Header from '../../components/Header';
import MarkdownRender from '../../components/MarkdownRender';
import Editor from '@monaco-editor/react';
import './style.css';
import { UploadOutlined ,SaveOutlined,CaretUpOutlined } from '@ant-design/icons';
import { addArticle } from '../../api/mockData';
import { getCurrentUserInfo } from '../../api/mockData';
const WritePost = () => {
  const [content, setContent] = useState('');
  const [theme, setTheme] = useState('light');
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const userInfo = getCurrentUserInfo();
  // 编辑器加载完成时获取实例
  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
    // 初始化时立即触发一次布局，确保编辑器渲染
    editor.layout(); 
  };

  // 手动调整编辑器大小
  const resizeEditor = () => {
    if (editorRef.current) {
      requestAnimationFrame(() => {
        editorRef.current.layout();
      });
    }
  };

  useEffect(() => {
    // 组件挂载完成后，主动触发一次布局
    resizeEditor();

    if (containerRef.current) {
      const resizeObserver = new ResizeObserver(() => resizeEditor());
      resizeObserver.observe(containerRef.current);

      // 组件卸载时清理
      return () => {
        resizeObserver.disconnect();
      };
    }

  }, []);

  const uploadArticle = async () => {
    try {
      // 1. 校验并获取表单数据（触发表单验证，确保必填项有值）
      const formValues = await form.validateFields();
      // formValues结构：{ title: '输入的标题', summary: '输入的摘要' }

      // 2. 构造addArticle需要的所有参数
      const articleData = {
        title: formValues.title,
        summary: formValues.summary,
        content: content, // 编辑器的Markdown内容
        author: userInfo.getName(), // 可替换为实际登录用户信息
        createTime: new Date().toISOString(), // 当前创建时间
        updateTime: new Date().toISOString(), // 当前更新时间
        isPublished: true // 是否发布（可改为状态控制）
      };

      // 3. 调用addArticle接口，传入收集到的所有数据
      const result = addArticle(
        articleData.title,
        articleData.summary,
        articleData.content,
        articleData.author,
        articleData.createTime,
        articleData.updateTime,
        articleData.isPublished
      );

      // 4. 提交成功后的处理
      console.log('文章提交成功：', result);
      setOpen(false); // 关闭Modal
      form.resetFields(); // 重置表单
      setContent(''); // 清空编辑器（可选）
      alert('文章发布成功！');
    } catch (errorInfo) {
      // 表单验证失败时的处理（比如必填项未填）
      console.error('表单验证失败：', errorInfo);
      alert('文章发布失败！');
    }
  };


  return (
    <div className="write-post-container">
      <Header index={1} />
      <Splitter className="write-post-maincontainer">
        <Splitter.Panel
          ref={containerRef}
          defaultSize="50%"
          min="30%"
          max="70%"
          style={{ padding: 0 }}
          className="write-post-editor"
          onResize={resizeEditor} // 分割线拖动时触发布局
        >
          <Editor
            height="100%" 
            language="markdown"
            value={content}
            onChange={setContent}
            theme={theme}
            onMount={handleEditorDidMount}
            options={{
              minimap: { enabled: true },
              fontSize: 16,
              lineNumbers: 'on',
              wordWrap: 'on',
              automaticLayout: false,
            }}
          />
        </Splitter.Panel>
        <Splitter.Panel
          defaultSize="50%"
          min="30%"
          max="70%"
          style={{ padding: 0 }}
          className="write-post-preview"
        >
          <MarkdownRender text={content} />
        </Splitter.Panel>
      </Splitter>
      <FloatButton icon={<UploadOutlined />} onClick={() => setOpen(true)} />
      <Modal
         title = "编辑发布信息"
         closeable = {true}
         width = {600}
         open = {open}
         onOk = {uploadArticle}
         onCancel = {() => setOpen(false)}
      >
        <div>
          <Form form = {form} layout='vertical' >
            <Form.Item name="title" label="标题" rules={[{ required: true, message: '请输入标题' }]}> 
              <Input placeholder="请输入标题" />
            </Form.Item>
            <Form.Item name="summary" label="摘要" rules={[{ required: true, message: '请输入摘要' }]}> 
              <Input placeholder="请输入摘要" />
            </Form.Item>
            
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default WritePost;